var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12 gutter-xs" },
      [
        _c(
          "q-field",
          {
            attrs: {
              icon: _vm.icone,
              disabled: _vm.desabilitar,
              error: _vm.mensagemErro.length > 0,
              "error-label": _vm.mensagemErro,
              count: _vm.dTamanho
            }
          },
          [
            _c(
              "q-input",
              {
                ref: "inputText",
                attrs: {
                  name: _vm.name,
                  id: _vm.id,
                  color: "primary",
                  "float-label": _vm.etiqueta,
                  placeholder: _vm.placeholder,
                  maxlength: _vm.dTamanho,
                  disable: _vm.desabilitar
                },
                on: {
                  blur: _vm.validarBlur,
                  change: _vm.change,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    return _vm.chamarFuncaoNoEnter($event)
                  }
                },
                model: {
                  value: _vm.termo,
                  callback: function($$v) {
                    _vm.termo = $$v
                  },
                  expression: "termo"
                }
              },
              [
                _c("q-autocomplete", {
                  ref: "autoComplete",
                  attrs: {
                    name: _vm.name,
                    id: _vm.id,
                    "min-characters": 1,
                    "max-results": 20,
                    debounce: 100,
                    separator: true,
                    disabled: _vm.desabilitar
                  },
                  on: { search: _vm.search, selected: _vm.select }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 text-right margin-neg" },
      [
        _c(
          "q-btn",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.itemSelecionado,
                expression: "itemSelecionado"
              }
            ],
            staticClass: "clear-botao",
            attrs: { disabled: _vm.desabilitar, flat: "" },
            on: { click: _vm.limpar }
          },
          [
            _c("q-icon", {
              attrs: { name: "close", size: "20px", disabled: _vm.desabilitar }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }